<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'name')">{{ schema.fields.name.label }}</th>
        <th v-if="canSee(schema, 'type')">{{ schema.fields.type.label }}</th>
        <th v-if="canSee(schema, 'description')">
          {{ schema.fields.description.label }}
        </th>
        <th v-if="canSee(schema, 'roles')">{{ schema.fields.roles.label }}</th>
        <th v-if="canSee(schema, 'params')">
          {{ schema.fields.params.label }}
        </th>
        
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'name')">
          <o-widget-wrapper
            :schema="schema"
            name="name"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].name"
              :form-state="formState"
              name="name"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.name"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'type')">
          <o-widget-wrapper
            :schema="schema"
            name="type"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].type"
              :items="optionCodeActivityTypeItems"
              text-field="description"
              value-field="id"
              sort-field="description"
              :form-state="formState"
              :loading="optionCodeActivityTypeWorking"
              name="type"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.type"
              allow-add
              store-name="CodeActivityType"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <code-activity-type-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></code-activity-type-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'description')">
          <o-widget-wrapper
            :schema="schema"
            name="description"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].description"
              :form-state="formState"
              name="description"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.description"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'roles')">
          <o-widget-wrapper
            :schema="schema"
            name="roles"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <activity-user-role-form-table
              v-model="items[index].roles"
              :validators="validators.$each[index].roles"
              :form-state="formState"
              :label="schema.fields.roles.label"
              :level="level + 1"
              :server-errors="_se.roles"
            >
            </activity-user-role-form-table>
            <!-- UNCOMMENT TO USE Cards
<activity-user-role-form-cards v-model="items[index].roles"
    :validators="validators.$each[index].roles"
    :form-state="formState"
    :label="schema.fields.roles.label"
    :level="level+1"
    :server-errors="_se.roles">
</activity-user-role-form-cards>
-->
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'params')">
          <o-widget-wrapper
            :schema="schema"
            name="params"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              name="params"
              v-model="items[index].params"
              :form-state="formState"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.params"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../../vue-ocom/mixins";
import OItemEditableTable from "../../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../../vue-ocom/components/layout/OSection";


export default {
  name: "ProcessActivityFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("ProcessActivity"),
    CreateCodeTableFetchMixin(["CodeActivityType"]),
  ],
  components: { OItemEditableTable, OSection },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.ProcessActivity,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.ProcessActivity),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>